module.exports = __webpack_public_path__ + "img/logo.d42296ad.png";